import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css                                   */
const ProductBlockActionSuccessText = () => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-action-success-text", "data-t": "add-to-cart-success-text" }, /* @__PURE__ */ React.createElement(Icon, { name: "checkmark" }), /* @__PURE__ */ React.createElement(Text, { component: "span" }, getLabel("cart.success.addedToCart")));
};
export {
  ProductBlockActionSuccessText
};
//# sourceMappingURL=ProductBlockActionSuccessText.js.map
